import { baseService } from "service/base";

class DeviceStatusService {
  /*
   * This service is responsible for fetching device status
   * (online, offline, hibernating) states from the api.
   */
  loadByAccount(accountId) {
    return baseService.get(`/api/account/${accountId}/device-statuses`);
  }
}

const deviceStatusService = new DeviceStatusService();

export { deviceStatusService };
